import { render } from "./MathGame.vue?vue&type=template&id=765455b0&scoped=true"
import script from "./MathGame.vue?vue&type=script&lang=ts"
export * from "./MathGame.vue?vue&type=script&lang=ts"

import "./MathGame.vue?vue&type=style&index=0&id=765455b0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-765455b0"

export default script